import { Button } from "@material-ui/core";
import { useEffect } from "react";
import en from "../../../lang/en-us";
import SuccessScreen from "../SuccessScreen";
const { dashboard } = en;

export default function UpdateIFSCSuccess(props: any) {
  const { successMessage } = props.location.state;
  return (
    <div className="curved-bg">
      <SuccessScreen
        heading={dashboard.UpdateForm15.Success.back}
        backLink="nct"
        successMessage={successMessage}
        info1={dashboard.UpdateForm15.Success.subHeadingInfo1}
        note={dashboard.UpdateNominee.Success.investorNote}
        // infospan2={`${reqId}`}
        info3={dashboard.UpdateForm15.Success.subHeadingInfo3}
        list={[]}
        handleClick={() => props.history.push("/new-transaction")}
        backNavigation={() => props.history.push("/portal/nct")}
      />
    </div>
  );
}
